import React, {Component} from 'react';
import './IAgriculture.css';
import IndustryIndividualCard from '../Components/IndustryIndividualCard/IndustryIndividualCard.js'
import agricultureCover from '../../../images/individual/agriculture/AgriCover.jpg';
import agricultureImgReforestation from '../../../images/individual/agriculture/AgriReforestation.jpg';
export default class IAgriculture extends Component {
	render() {
		return (
			<div className="i_agriculture_container">
				<div className="i_agriculture_container_cover_image">
				<div className="i_agriculture_container_cover_text">AGRICULTURE</div>
					<img src={agricultureCover} />
				</div>
				<div className="i_agriculture_subtitle">
					<span>PPI has an unparalleled ability to make a significant and positive impact in Asia-Pacific through its world class investment management team.</span>
				</div>
				<div className="i_agriculture_content">
				<IndustryIndividualCard
					link='/agriculture/reforestation'
					image={agricultureImgReforestation}
					clickable={true}
					moreEnabled = 'true'
					title='REFORESTATION'
					description1='Working with renowned scientists to offer bio-technological enhancements, we endeavor to expedite growth and increase yield of plant saplings. As an environmentally conscious developer, we wish to propagate efficient re-forestation methods, to benefit massive timber industry in this region.'
					description2=' Over the past decades, production in many traditional timber-producing countries has been restricted, due to rapid depleting of world’s reserves of natural timber and increasing environmental awareness. As a result, limits were placed on commercial access to public & private timberlands. In early 1990s, an environment of shrinking timber supply and increasing wood fiber prices sparked concerns about the ability of global timber production to meet future wood fiber demand.'
					description3='Timber production in places such as Sarawak has exhausted much land. Vast areas of forest has been harvested for timber revenue & cleared for agricultural activities. Depletion of mature natural timber results in unsustainable growth, which can be restored through reforestation. The combination of greater biological yields, shorter rotations & higher prices has promoted continual investment in re-forestation plantation projects to boost the supply of wood fiber for commercial purposes.'
				/>
				</div>
			</div>
		);
	}
}
